'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Asset-module_container__BoJBP{animation-timing-function:ease-in-out;background-position:50%;background-repeat:no-repeat;background-size:cover;display:inline-block;height:100%;vertical-align:middle;width:100%}.Asset-module_link__34K8V{display:block;height:100%;width:100%}.Asset-module_image__4OJ3K{vertical-align:middle;width:100%}";
var styles = {"container":"Asset-module_container__BoJBP","link":"Asset-module_link__34K8V","image":"Asset-module_image__4OJ3K"};
styleInject["default"](css_248z, '24edf2ea-d535-4780-b8e6-d79426ac6631');

exports["default"] = styles;
